// import React, { useMemo, useState, useEffect } from 'react';
// import {
//   PaginationState,
//   useReactTable,
//   getCoreRowModel,
//   ColumnDef,
//   flexRender,
// } from '@tanstack/react-table';

// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
// import { Spin, Button } from 'antd';

// import { Patient } from '../../../Sections/PatientsList/patientsList.section.custom';
// import { usePaginatedPatients } from '../../../helpers/api/patients/patients';
// import MinimunPatientForm from './minmumPatientform';
// import { MdArrowBackIosNew } from 'react-icons/md';
// import { useDebouncedCallback } from 'use-debounce';
// import Modal from '../modal';
// import { ChevronLeft, ChevronRight } from 'lucide-react';

// interface PatientTableSelectionProps {
//   selectedRow: any; // Adjust type as needed
//   showPatientModal: boolean;
//   setShowPatientModal: React.Dispatch<React.SetStateAction<boolean>>;
//   setSelectedRow: React.Dispatch<React.SetStateAction<any>>;
//   handlePatientSelection?: () => void;
//   modal?: boolean;
//   mode?: string;
//   show?: boolean;
//   onAddPatientClick?: () => void;
// }

// function PatientTableSelectionRealtime({
//   handlePatientSelection,
//   selectedRow,
//   setSelectedRow,
//   showPatientModal,
//   setShowPatientModal,
//   modal = true,
//   mode,
//   onAddPatientClick,
// }: PatientTableSelectionProps) {
//   const [pagination, setPagination] = useState<PaginationState>({
//     pageIndex: 0,
//     pageSize: 6,
//   });

//   const [filters, setFilters] = useState({});
//   const [searchMode, setSearchMode] = useState('OR');

//   const handleFilterChange = e => {
//     console.log('==================== oo', e.target.value);

//     const { value } = e.target;

//     setFilters(prev => {
//       const updatedFilters = { ...prev };

//       if (value === '') {
//         delete updatedFilters['patient_name'];
//         delete updatedFilters['patient_last_name'];
//         delete updatedFilters['email'];
//       } else {
//         updatedFilters['patient_name'] = value;
//         updatedFilters['patient_last_name'] = value;
//         updatedFilters['email'] = value;
//       }

//       console.log('================= updatedFilters ', updatedFilters);

//       return updatedFilters;
//     });
//   };

//   const debouncedFilterChange = useDebouncedCallback(handleFilterChange, 500);

//   const buildFilters = (filters, searchMode) => {
//     const updatedFilters = {};

//     Object.keys(filters).forEach(key => {
//       const newKey = `${key}__ilike`;
//       const newValue = `%${filters[key]}%`;
//       updatedFilters[newKey] = newValue;
//     });

//     if (searchMode === 'OR') {
//       return { condition__or: updatedFilters };
//     }

//     return updatedFilters;
//   };

//   const [globalFilter, setGlobalFilter] = useState<string>('');
//   const { data, isError, isLoading, refetch } = usePaginatedPatients(
//     pagination.pageIndex + 1,
//     pagination.pageSize,
//     {
//       ...(Object.keys(buildFilters(filters, searchMode)).length > 0 && {
//         filters: JSON.stringify(buildFilters(filters, searchMode)),
//       }),
//     }
//   );

//   console.log('================== data', data?.items);

//   const columns = useMemo<ColumnDef<any>[]>(
//     () => [
//       {
//         accessorKey: 'patient_last_name',
//         cell: info => info.getValue(),
//         header: () => <span>Last Name</span>,
//       },
//       {
//         accessorKey: 'patient_name',
//         cell: info => info.getValue(),
//         header: () => <span>First Name</span>,
//       },
//       {
//         accessorKey: 'email',
//         cell: info => info.getValue(),
//         header: () => <span>Email</span>,
//       },
//       {
//         accessorKey: 'birth_date',
//         cell: info => formatBirthDate(info.getValue()),
//         header: () => <span>Date Of Birth</span>,
//       },
//       {
//         accessorKey: 'phone_number',
//         cell: info => info.getValue(),
//         header: () => <span>Phone Number</span>,
//       },
//       {
//         accessorKey: 'policy_number',
//         cell: info => info.getValue(),
//         header: () => <span>Policy Number</span>,
//       },
//     ],
//     []
//   );
//   function formatBirthDate(birthDate: any) {
//     const options: any = { month: 'long', day: 'numeric', year: 'numeric' };
//     return new Date(birthDate).toLocaleDateString('en-US', options);
//   }
//   const table = useReactTable({
//     data: data?.items ?? [],
//     columns,
//     rowCount: data?.total_count ?? 0,
//     state: {
//       pagination,
//     },
//     onPaginationChange: setPagination,
//     getCoreRowModel: getCoreRowModel(),
//     manualPagination: true,
//     debugTable: true,
//   });

//   const handleRowClick = (row: any) => {
//     console.log('row', row);

//     const newRowSelected = {
//       row_id: row.id,
//       patient: row.original,
//     };

//     setSelectedRow(prevSelectedRow => {
//       if (prevSelectedRow && prevSelectedRow.row_id === newRowSelected.row_id) {
//         return null;
//       }
//       return newRowSelected;
//     });
//   };
//   const handlePatientAddClick = (patient: Patient) => {
//     const patientData = {
//       patient_id: String(patient.id),
//       patient_name: `${patient.patient_name} ${patient.patient_last_name}`.trim(),
//     };
//   };

//   useEffect(() => {
//     setPagination(prev => ({ ...prev, pageIndex: 0 })); // Reset to first page when filters change
//     refetch();
//   }, [filters]);
//   const renderContent = (okButton: Boolean) => {
//     return (
//       <div className="rounded-md p-2">
//         <div className="flex w-full items-center justify-between pb-1">
//           <div className="text-lg font-medium text-gray-900">Select Patient</div>
//           <div className="flex space-x-2">
//             <input
//               type="text"
//               // value={globalFilter}
//               onChange={debouncedFilterChange}
//               placeholder="Search Patients..."
//               className="h-7 w-full rounded-md border p-1 focus:outline-none focus:ring-0"
//             />
//           </div>
//         </div>
//         <div className={`w-full ${mode !== 'blind' ? '' : ' flex justify-end'}`}>
//           {mode !== 'blind' ? (
//             <MinimunPatientForm handlePatientAddClick={handlePatientAddClick} />
//           ) : (
//             <button
//               className="flex h-7 items-center rounded-md border border-[#005dd4] bg-[#F7FAFE] px-4 py-2 text-[#2886C7]"
//               type="submit"
//               onClick={onAddPatientClick}
//             >
//               Add Patient
//             </button>
//           )}
//         </div>
//         <table className="w-full border-collapse rounded-md border border-gray-200 text-sm">
//           <thead className="h-10 border-t border-dashed border-gray-200 bg-gray-100 p-2 text-left text-gray-500">
//             {table.getHeaderGroups().map(headerGroup => (
//               <tr key={headerGroup.id}>
//                 {headerGroup.headers.map(header => (
//                   <th
//                     className="p-2"
//                     key={header.id}
//                     colSpan={header.colSpan}
//                   >
//                     {header.isPlaceholder
//                       ? null
//                       : flexRender(header.column.columnDef.header, header.getContext())}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody className="text-sm font-medium leading-5 text-[#686C82]">
//             {isLoading ? (
//               <tr>
//                 <td
//                   colSpan={columns.length}
//                   className="p-4 text-center"
//                 >
//                   <Spin size="large" /> {/* Loading spinner */}
//                   <div>Loading patients...</div>
//                 </td>
//               </tr>
//             ) : isError ? (
//               <tr>
//                 <td
//                   colSpan={columns.length}
//                   className="p-4 text-center text-red-500"
//                 >
//                   Error loading patients. Please try again.
//                 </td>
//               </tr>
//             ) : table.getRowModel().rows.length > 0 ? (
//               table.getRowModel().rows.map(row => (
//                 <tr
//                   id={`table-row-${row.id}`}
//                   key={row.id}
//                   className={`h-10 cursor-pointer border-t border-b border-gray-200 ${row.id == selectedRow?.row_id ? 'bg-[#2886C7] text-white' : 'hover:bg-blue-100'}`}
//                   onClick={() => handleRowClick(row)}
//                 >
//                   {row.getVisibleCells().map(cell => (
//                     <td
//                       key={cell.id}
//                       className="p-2"
//                     >
//                       {flexRender(cell.column.columnDef.cell, cell.getContext())}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td
//                   colSpan={columns.length}
//                   className="p-4 text-center"
//                 >
//                   No data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>

//         <div className="flex items-center justify-end gap-2 pt-1">
//           <span className="flex items-center gap-1">
//             <div>Page</div>
//             <strong>
//               {table.getState().pagination.pageIndex + 1} of {table.getPageCount().toLocaleString()}
//             </strong>
//           </span>
//           <button
//             className="text-[14px] font-semibold text-[#005DD4]"
//             onClick={() => table.previousPage()}
//             disabled={!table.getCanPreviousPage()}
//           >
//             <LeftOutlined />
//           </button>
//           <button
//             className="text-[14px] font-semibold text-[#005DD4]"
//             onClick={() => table.nextPage()}
//             disabled={!table.getCanNextPage()}
//           >
//             <RightOutlined />
//           </button>
//         </div>
//         {okButton && (
//           <div className={`mt-5 flex w-full justify-between p-5`}>
//             <div className={`flex w-full justify-end px-4`}>
//               <button
//                 className={`rounded-md border border-[#2886c7] bg-[#2886c7] py-1 px-4 text-white hover:bg-white hover:text-[#2886c7] ${selectedRow ? 'cursor-pointer' : 'cursor-not-allowed opacity-50'}`}
//                 disabled={isLoading}
//                 onClick={() => {
//                   if (selectedRow) {
//                     handlePatientSelection();
//                   }
//                 }}
//               >
//                 OK
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };
//   if (modal) {
//     return (
//       <div
//         className={`${showPatientModal ? 'visible' : 'hidden'} fixed inset-0 z-40 flex h-full flex-col`}
//       >
//         <Modal
//           isOpen={showPatientModal}
//           onClose={() => {
//             setShowPatientModal(!showPatientModal);
//           }}
//           size={'large'}
//           className="bg-[#F2F8FF]"
//         >
//           <Modal.Header
//             title={'Select Patient'}
//             onClose={() => {
//               setShowPatientModal(!showPatientModal);
//             }}
//             displayClose={true}
//           />
//           <Modal.Content>{renderContent(true)}</Modal.Content>
//         </Modal>
//       </div>
//     );
//   } else {
//     return (
//       <div className="flex h-full w-full flex-col rounded-md bg-[#F2F8FF]">
//         {renderContent(false)}
//       </div>
//     );
//   }
// }

// export default PatientTableSelectionRealtime;
import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PaginationState,
  useReactTable,
  getCoreRowModel,
  ColumnDef,
  flexRender,
} from '@tanstack/react-table';
import { Spin } from 'antd';
import { Patient } from '../../../Sections/PatientsList/patientsList.section.custom';
import { usePaginatedPatients } from '../../../helpers/api/patients/patients';
import MinimunPatientForm from './minmumPatientform';
import { useDebouncedCallback } from 'use-debounce';
import Modal from '../modal';
import { ChevronLeft, ChevronRight, Search, Plus, Check } from 'lucide-react';

interface PatientTableSelectionProps {
  selectedRow: any;
  showPatientModal: boolean;
  setShowPatientModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedRow: React.Dispatch<React.SetStateAction<any>>;
  handlePatientSelection?: () => void;
  modal?: boolean;
  mode?: string;
  show?: boolean;
  onAddPatientClick?: () => void;
}

function PatientTableSelectionRealtime({
  handlePatientSelection,
  selectedRow,
  setSelectedRow,
  showPatientModal,
  setShowPatientModal,
  modal = true,
  mode,
  onAddPatientClick,
}: PatientTableSelectionProps) {
  const { t } = useTranslation('RecentPatients');
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 6,
  });

  const [filters, setFilters] = useState({});
  const [searchMode, setSearchMode] = useState('OR');

  const handleFilterChange = (e) => {
    const { value } = e.target;

    setFilters((prev) => {
      const updatedFilters = { ...prev };

      if (value === '') {
        delete updatedFilters['patient_name'];
        delete updatedFilters['patient_last_name'];
        delete updatedFilters['email'];
      } else {
        updatedFilters['patient_name'] = value;
        updatedFilters['patient_last_name'] = value;
        updatedFilters['email'] = value;
      }

      return updatedFilters;
    });
  };

  const debouncedFilterChange = useDebouncedCallback(handleFilterChange, 500);

  const buildFilters = (filters, searchMode) => {
    const updatedFilters = {};

    Object.keys(filters).forEach((key) => {
      const newKey = `${key}__ilike`;
      const newValue = `%${filters[key]}%`;
      updatedFilters[newKey] = newValue;
    });

    if (searchMode === 'OR') {
      return { condition__or: updatedFilters };
    }

    return updatedFilters;
  };

  const [globalFilter, setGlobalFilter] = useState<string>('');
  const { data, isError, isLoading, refetch } = usePaginatedPatients(
    pagination.pageIndex + 1,
    pagination.pageSize,
    {
      ...(Object.keys(buildFilters(filters, searchMode)).length > 0 && {
        filters: JSON.stringify(buildFilters(filters, searchMode)),
      }),
    }
  );

  function formatBirthDate(birthDate: any) {
    const options: any = { month: 'long', day: 'numeric', year: 'numeric' };
    return new Date(birthDate).toLocaleDateString('en-US', options);
  }

  const columns = useMemo<ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'patient_last_name',
        cell: (info) => info.getValue(),
        header: () => (
          <span className="font-medium text-gray-600">Last Name</span>
        ),
      },
      {
        accessorKey: 'patient_name',
        cell: (info) => info.getValue(),
        header: () => (
          <span className="font-medium text-gray-600">First Name</span>
        ),
      },
      {
        accessorKey: 'email',
        cell: (info) => info.getValue(),
        header: () => <span className="font-medium text-gray-600">Email</span>,
      },
      {
        accessorKey: 'birth_date',
        cell: (info) => formatBirthDate(info.getValue()),
        header: () => (
          <span className="font-medium text-gray-600">Date Of Birth</span>
        ),
      },
      {
        accessorKey: 'phone_number',
        cell: (info) => info.getValue(),
        header: () => (
          <span className="font-medium text-gray-600">Phone Number</span>
        ),
      },
      {
        accessorKey: 'policy_number',
        cell: (info) => info.getValue(),
        header: () => (
          <span className="font-medium text-gray-600">Policy Number</span>
        ),
      },
    ],
    []
  );

  const table = useReactTable({
    data: data?.items ?? [],
    columns,
    rowCount: data?.total_count ?? 0,
    state: {
      pagination,
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    manualPagination: true,
    debugTable: true,
  });

  const handleRowClick = (row: any) => {
    const newRowSelected = {
      row_id: row.id,
      patient: row.original,
    };

    setSelectedRow((prevSelectedRow) => {
      if (prevSelectedRow && prevSelectedRow.row_id === newRowSelected.row_id) {
        return null;
      }
      return newRowSelected;
    });
  };

  const handlePatientAddClick = (patient: Patient) => {
    const patientData = {
      patient_id: String(patient.id),
      patient_name:
        `${patient.patient_name} ${patient.patient_last_name}`.trim(),
    };
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    refetch();
  }, [filters]);

  const renderContent = (okButton: Boolean) => {
    return (
      <div className="rounded-lg p-4 shadow-sm">
        <div className="flex w-full items-center justify-between pb-4">
          {/* <div className="text-xl font-semibold text-gray-800">Select Patient</div> */}
          <div className="relative w-1/3">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <Search size={16} className="text-gray-400" />
            </div>
            <input
              type="text"
              onChange={debouncedFilterChange}
              placeholder="Search patients..."
              className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 text-sm transition-all duration-200 focus:outline-none"
            />
          </div>
        </div>

        <div
          className={`w-full ${
            mode !== 'blind' ? '' : 'flex justify-end'
          } mb-4`}
        >
          {mode !== 'blind' ? (
            <MinimunPatientForm handlePatientAddClick={handlePatientAddClick} />
          ) : (
            <button
              className="rounded-lg inline-flex space-x-2 text-sm px-6 py-2 font-medium transition-all duration-200 text-blue-600 hover:text-blue-700 cursor-pointer border border-blue-600 hover:border-blue-700"
              type="button"
              onClick={onAddPatientClick}
            >
              <Plus size={16} /> Add Patient
            </button>
          )}
        </div>

        <div className="overflow-hidden rounded-lg border border-gray-200">
          <table className="w-full border-collapse text-sm">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="bg-gray-50">
                  {headerGroup.headers.map((header) => (
                    <th
                      className="p-3 text-left"
                      key={header.id}
                      colSpan={header.colSpan}
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={columns.length} className="p-8 text-center">
                    <div className="flex flex-col items-center justify-center gap-2">
                      <Spin size="large" />
                      <div className="text-title-page-color-100">
                        Loading patients...
                      </div>
                    </div>
                  </td>
                </tr>
              ) : isError ? (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="p-8 text-center text-red-500"
                  >
                    <div className="flex flex-col items-center justify-center gap-2">
                      <div className="text-lg font-medium">
                        Error loading patients
                      </div>
                      <div className="text-sm">Please try again later</div>
                    </div>
                  </td>
                </tr>
              ) : table.getRowModel().rows.length > 0 ? (
                table.getRowModel().rows.map((row) => (
                  <tr
                    id={`table-row-${row.id}`}
                    key={row.id}
                    className={`border-t border-gray-200 cursor-pointer transition-colors duration-150 text-title-page-color-100
                      ${
                        row.id == selectedRow?.row_id
                          ? 'bg-card-color-200 hover:bg-card-color-200'
                          : 'hover:bg-base-100'
                      }`}
                    onClick={() => handleRowClick(row)}
                  >
                    {row.getVisibleCells().map((cell) => (
                      <td key={cell.id} className="p-3">
                        <div className="flex items-center">
                          {row.id == selectedRow?.row_id &&
                            cell.column.id === 'patient_last_name' && (
                              <div className="mr-2 flex h-5 w-5 items-center justify-center rounded-full bg-blue-600 text-white">
                                <Check size={12} />
                              </div>
                            )}
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="p-8 text-center text-gray-500"
                  >
                    {t('noPatientsFound')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-between mt-4">
          <div className="text-sm text-gray-500">
            Showing {pagination.pageIndex * pagination.pageSize + 1} to{' '}
            {Math.min(
              (pagination.pageIndex + 1) * pagination.pageSize,
              data?.total_count || 0
            )}{' '}
            of {data?.total_count || 0} patients
          </div>

          <div className="flex items-center gap-3">
            <button
              className={`flex items-center justify-center rounded-md p-2 ${
                !table.getCanPreviousPage()
                  ? 'text-gray-300 cursor-not-allowed'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
              onClick={() => table.previousPage()}
              disabled={!table.getCanPreviousPage()}
            >
              <ChevronLeft size={16} />
            </button>

            <span className="text-sm font-medium text-title-page-color-100">
              Page {table.getState().pagination.pageIndex + 1} of{' '}
              {table.getPageCount()}
            </span>

            <button
              className={`flex items-center justify-center rounded-md p-2 ${
                !table.getCanNextPage()
                  ? 'text-gray-300 cursor-not-allowed'
                  : 'text-gray-700 hover:bg-gray-100'
              }`}
              onClick={() => table.nextPage()}
              disabled={!table.getCanNextPage()}
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>

        {okButton && (
          <div className="mt-6 flex justify-end">
            <button
              className={`rounded-lg text-xs px-6 py-2 font-medium transition-all duration-200
                ${
                  selectedRow
                    ? 'bg-blue-600 text-white hover:bg-blue-700 cursor-pointer'
                    : 'bg-gray-200 text-gray-400 cursor-not-allowed'
                }`}
              disabled={!selectedRow || isLoading}
              onClick={() => {
                if (selectedRow) {
                  handlePatientSelection();
                }
              }}
            >
              Select Patient
            </button>
          </div>
        )}
      </div>
    );
  };

  if (modal) {
    return (
      <div
        className={`${
          showPatientModal ? 'visible' : 'hidden'
        } fixed inset-0 z-40 flex h-full flex-col`}
      >
        <Modal
          isOpen={showPatientModal}
          onClose={() => {
            setShowPatientModal(!showPatientModal);
          }}
          size={'large'}
          className="bg-gray-50"
        >
          <Modal.Header
            title={'Select Patient'}
            onClose={() => {
              setShowPatientModal(!showPatientModal);
            }}
            displayClose={true}
          />
          <Modal.Content classContent="bg-card-color-100">
            {renderContent(true)}
          </Modal.Content>
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="flex h-full w-full flex-col rounded-lg border">
        {renderContent(false)}
      </div>
    );
  }
}

export default PatientTableSelectionRealtime;
